function NotFoundPage() {
  return <h1>404 Error! Page not Found!</h1>;
}

export default NotFoundPage;
